import { render, staticRenderFns } from "./TheHotSignForm.vue?vue&type=template&id=137fb84a&scoped=true&lang=pug&"
import script from "./TheHotSignForm.vue?vue&type=script&lang=js&"
export * from "./TheHotSignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137fb84a",
  null
  
)

export default component.exports